import { render, staticRenderFns } from "./StatistiquesProductionLot.vue?vue&type=template&id=883aa438&"
import script from "./StatistiquesProductionLot.vue?vue&type=script&lang=js&"
export * from "./StatistiquesProductionLot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports